module.exports = __webpack_public_path__ + "static/media/Forbidden-red Icon.807c3bb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/Forbidden-red Icon.png
// module id = 184
// module chunks = 0